import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Overlay, StyledPopup, CloseIcon } from './styled';

const Popup = ({ children, onClose, small, className }) => {
  useLayoutEffect(() => {
    document.body.style.overflowY = 'hidden';
    document.documentElement.style.height = '100%';
    return () => {
      document.body.style.overflowY = null;
      document.documentElement.style.height = null;
    };
  }, []);

  return (
    <Overlay onClick={onClose}>
      <StyledPopup className={className} small={small}>
        <CloseIcon onClick={onClose} />
        {children}
      </StyledPopup>
    </Overlay>
  );
};

Popup.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  small: PropTypes.bool,
  className: PropTypes.string
};

export default Popup;
